import { AuthState } from "@okta/okta-auth-js";

export const buildHeader = (authState : AuthState) => {
    return {
        'Authorization': 'Bearer ' + authState.idToken?.idToken,
        'Content-Type': 'application/json'
    }
};
export const buildTextHeader = (authState : AuthState) => {
    return {
        'Authorization': 'Bearer ' + authState.idToken?.idToken,
        'Content-Type': 'text/plain'
    }
};
export const buildCsvHeader = (authState : AuthState) => {
    return {
        'Authorization': 'Bearer ' + authState.idToken?.idToken,
        'Content-Type': 'text/csv'
    }
};
export const buildFileHeader = (authState : AuthState) => {
    return {
        'Authorization': 'Bearer ' + authState.idToken?.idToken,
    }
};
export const buildExcelHeader = (authState: AuthState) => {
    return {
        'Authorization': 'Bearer ' + authState.idToken?.idToken,
        'Content-Type': 'application/json'
    };
};
